import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgCrifIcon = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 48,
	height: 48,
	viewBox: "0 0 48 48",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [/* @__PURE__ */ _jsx("rect", {
		width: 48,
		height: 48,
		rx: 8,
		fill: "white"
	}), /* @__PURE__ */ _jsx("path", {
		d: "M24.0143 23.5396C26.105 22.8396 26.9735 22.4696 28.1289 23.6616C29.2812 24.8536 29.8648 26.42 29.8648 26.42C29.8648 26.42 28.8755 27.3854 27.269 27.9549C26.2094 28.3336 24.9115 28.5043 24.9115 28.5043C24.9115 28.5043 25.2245 27.417 25.5584 26.5219C25.888 25.6225 26.8854 23.5396 26.8854 23.5396L25.8672 23.4249C25.8672 23.4249 24.682 24.9798 23.739 27.1243C23.0211 28.7596 22.5997 30.6 22.5997 30.6C22.5997 30.6 26.3053 30.1926 28.4508 29.517C30.5953 28.8414 32.1857 28.2346 32.5943 27.787C33.0073 27.3395 33.7673 26.2895 34.2597 23.564C34.6771 21.2488 33.9378 19.6078 33.9378 19.6078C33.9378 19.6078 33.6703 19.4859 32.5605 19.9664C32.3474 20.0597 32.1563 20.1615 31.9843 20.2591C31.6213 20.4671 31.1583 20.9189 30.9084 21.2488C31.2582 21.9732 31.6095 23.1208 31.3376 24.1335C30.1073 22.3103 29.0137 21.3492 28.0039 21.0164C26.539 20.5402 25.7669 20.7755 22.7957 22.0779C20.2042 23.214 15.447 25.9237 13.0266 27.3811C12.4173 27.7512 12 27.9993 12 27.9993C12 27.9993 21.7651 24.2956 24.0143 23.5396ZM28.8094 20.7353C28.8094 20.7353 29.6737 19.8646 31.3082 18.9853C33.1911 17.9683 36 17 36 17C36 17 33.7423 17.4074 30.7085 18.806C29.5767 19.331 28.1039 20.5115 28.1039 20.5115L28.8094 20.7353Z",
		fill: "#EE7E12"
	})]
});
export default SvgCrifIcon;
